module.exports = __webpack_public_path__ + "img/48.2.TN.3a5e4991.png";